import { render, staticRenderFns } from "./ContentPoolContent.vue?vue&type=template&id=8ec05a58&scoped=true"
import script from "./ContentPoolContent.vue?vue&type=script&lang=js"
export * from "./ContentPoolContent.vue?vue&type=script&lang=js"
import style0 from "./ContentPoolContent.vue?vue&type=style&index=0&id=8ec05a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec05a58",
  null
  
)

export default component.exports